module.exports = __webpack_public_path__ + "img/beenotes-logo-large.cca1ed71.svg";